<template>
    <section class="our__blog__section__container">
        <div class="wrapper__texts">
                <div class="low__text" v-if="fields" data-animate="slideUp">{{ fields['Title section'] }}</div>
                <div class="text" v-if="fields" data-animate="slideUp">{{ fields['Text section'] }}</div>
                <router-link :to="{ name: 'blogs' }" v-if="fields">{{ fields['Text button'] }}
                    <svg width="15.000000" height="10.000000" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs/>
              <path id="Union" d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
          </svg>
                </router-link>
        </div>
        <BlogList :array="blogs"></BlogList>
    </section>
</template>

<script>
import axios from 'axios';
import BlogList from './BlogList.vue';

    export default {
        components: {
            BlogList,
        },
        props: {
            fields: [Array,Object],
        },
        data() {
            return {
                blogs: [],
            }
        },
        methods: {
            async fetchBlogs() {
                try {
                    const response = await axios.get("/get/our-blogs");
                    if (response.data.result) {
                    this.blogs = response.data.blog;
                    }
                } catch (error) {
                    console.error("Ошибка при загрузке блогов:", error);
                }
            },
        },
        mounted () {
            this.fetchBlogs();
        },
    }
</script>

<style scoped>
.wrapper__texts{
    position: relative;
    margin-bottom: 36px;
}
.wrapper__texts .low__text{
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 10px;
}
.wrapper__texts .text{
/* Header/H1: 44px Medium */
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    max-width: 555px;
}
.wrapper__texts a{
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
@media (max-width: 1024px) {
    .wrapper__texts a{
        bottom: unset;
        top: 0;
    }
    .wrapper__texts .text{
        font-size: 32px;
        max-width: 100%;
    }
}
@media (max-width: 768px) {
    .wrapper__texts .text{
        font-size: 24px;
    }
}
</style>